<template>
  <div class="body">
    <!-- 标题部分开始 -->
    <div class="title-area">
      <h3>我的机手({{ machinerVoList.length || "0" }})</h3>
    </div>
    <!-- 标题部分结束 -->
    <!-- 列表部分开始 -->
    <el-scrollbar height="400px">
      <div class="machinerVoList-area">
        <div class="list-box" v-for="(item, index) in machinerVoList" :key="index">
          <!-- 头像姓名状态区域开始 -->
          <div class="top-info-area">
            <div class="top-left-area">
              <div class="head">
                {{ item.userName[0] }}
              </div>
              <div class="userName">
                {{ item.userName }}{{ item.isSelect == 1 ? "(已选择)" : "" }}
              </div>
            </div>
            <!-- <div class="top-right-area" v-if="item.copType == 2">
              <div class="symbol-y-area">
                <div :class="[item.status == 1 ? 'symbol green' : 'symbol red']"></div>
              </div>
              <div class="title">
                {{ item.status == 1? "工作中" : "空闲" }}
              </div>
            </div> -->
            <div class="top-right-area">
              <div class="symbol-y-area">
                <div :class="[item.status == 1 ? 'symbol green' : 'symbol red']"></div>
              </div>
              <div class="title">
                {{ item.status == 1? "工作中" : "空闲" }}
              </div>
            </div>
          </div>
          <!-- 头像姓名状态区域结束 -->
          <div class="info-box">
            <div class="info-title">电话：</div>
            <div>{{ item.userPhone || "无" }}</div>
          </div>
          <div class="info-box">
            <div class="info-title">位置：</div>
            <div>{{ item.areaName || "无" }}</div>
          </div>
          <div class="info-box">
            <div class="info-title">作业农机：</div>
            <div>{{ item.machineryName || "无" }}</div>
          </div>
          <!-- 操作按钮部分开始 -->
          <!-- <div class="button-area" v-if="item.copType == 2">
            <button class="cancel" v-if="item.status == 2" @click="delFP(item)">
              取消
            </button>
            <button class="cancel blue" v-if="!item.status" @click="checkMachiner(item)">
              选择
            </button>
          </div> -->
          <div class="button-area" v-if="item.copType == 2" >
            <button v-if="item.operateId" class="cancel" @click="delFP(item)">
              取消
            </button>
            <button v-if="!item.operateId" class="cancel blue" @click="checkMachiner(item)">
              选择
            </button>
          </div>
          <!-- 操作按钮部分结束 -->
        </div>
      </div>
      <!-- 列表部分结束 -->
    </el-scrollbar>
  </div>
</template>

<script>
import {
  selectCompanyMachiner,
  assignOperatorsCheck,
  assignOperators,
  deleteAssignOperators,
} from "@/api/njdd.js";
export default {
  props: ["orderData"],
  data() {
    return {
      machinerVoList: [], //我的机手列表
      tgOrderList: [], //托管订单列表（托管土地）
      zyzcList: [], //资源资产列表（自营土地）
    };
  },
  computed: {},
  watch: {
    orderData(e) {
      console.log("orderData变化", e);
      this.machinerVoList = [];
      this.machinerVoList = e;
    },
  },

  created() {
    //获取我的机手列表
    this.getOperatorList();
  },

  methods: {
    //获取数据列表
    async getOperatorList() {
      // console.log('这里是否执行了啊111111111111111111111111111111111111')
      // 设置新的状态值 copType 1代表用户没点击气泡 2代表点击了气泡
      // 拉取数据后将status都设置为null 等点击气泡之后再显示数据
      try {
        this.machinerVoList = [];
        this.ldtpOrders = [];
        this.xmxxList = [];
        let data = await selectCompanyMachiner();
        this.machinerVoList = data.data.machinerVoList || [];
        if (this.machinerVoList.length) {
          this.machinerVoList.forEach((item, index) => {
            item.status = null;
            item.copType = 1;
          });
        }
        // this.ldtpOrders = data.data.ldtpOrders || [];
        // this.xmxxList = data.data.xmxxList || [];
      } catch (error) {
        console.log("拉取数据错误", error);
      }
    },
    //选择机手前置校验
    async checkMachiner(e) {
      console.log(this.machinerVoList, '查看获取的this.machinerVoList')
      // 新增：判断是否有 status==2 的机手
      const hasStatus2 = this.machinerVoList.some(item => item.status === 2);
      if (hasStatus2) {
        try {
          await this.$confirm(
            "已有机手处于分配状态，是否继续分配？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          );
          // 用户点击确定，继续后续逻辑
        } catch {
          // 用户点击取消，直接返回
          return;
        }
      }
      // console.log("选择机手前置校验", e);
      let machinistOrderInfo = JSON.parse(
        localStorage.getItem("machinistOrderInfo")
      );
      // console.log("qeeq", machinistOrderInfo);
      if (!machinistOrderInfo) {
        return this.$message.error("请选择土地");
      }

      if (machinistOrderInfo.xmbsm && !machinistOrderInfo.cropName) {
        return this.$message.error("请选择作业环节");
      }

      console.log("1111--------------------", machinistOrderInfo);
      let params = {
        cropName: machinistOrderInfo.cropName || "",
        orderType: machinistOrderInfo.cropType,
        machinistId: e.id || "",
        machinistIdNow: machinistOrderInfo.machinistId || "",
        machinistName: e.userName || "",
        machinistNameNow: machinistOrderInfo.machinistName || "",
        orderId: machinistOrderInfo.orderId || "",
        xmbsm: machinistOrderInfo.xmbsm || "",
        tglx: machinistOrderInfo.tglx || "",
        operateId: machinistOrderInfo.operateId || "",
      };
      console.log('------查看params-----------',params)
      let res = await assignOperatorsCheck(params);
      console.log("查看检查机手回调", res);
      if (params.machinistIdNow) {
        // 有id说明已经分配过机手了
        let text =
          "当前资源已分配给机手" +
          params.machinistNameNow +
          "," +
          "是否更换为" +
          params.machinistName +
          "?";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          if (res.code == 0) {
            console.log("校验通过绑定机手");
            this.assignOperators(params);
          } else if (res.code == 1) {
            this.$message.error(res.msg);
          }
        });
      } else {
        if (res.code == 0) {
          console.log("校验通过绑定机手");
          this.assignOperators(params);
        } else if (res.code == 1) {
          this.$message.error(res.msg);
        }
      }
    },
    //分配机手
    async assignOperators(data) {
      console.log("查看入参data-----------", data);
      let res = await assignOperators({
        cropName: data.cropName || "",
        machinistId: data.machinistId || "",
        machinistIdNow: data.machinistIdNow || "",
        machinistName: data.machinistName || "",
        machinistNameNow: data.machinistNameNow || "",
        orderId: data.orderId || "",
        orderType: data.orderType,
        xmbsm: data.xmbsm || "",
        tglx:data.tglx||"",
        operateId: data.operateId || ""
      });
      if (res.code == 0) {
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
      this.getOperatorList();
      this.$emit("wdjsChange", { code: 1 }); //分配机手成功
    },
    //取消机手
    async delFP(e) {
      console.log("查看eeee", e);
      this.$confirm("是否取消分配？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.delWorker(e);
      });
    },
    //取消机手方法
    async delWorker(e) {
      console.log(e,'查看e是什么')
      const res = await deleteAssignOperators({
        // machineUserId: e.id,
        operateId: e.operateId,
      });
      if (res.code == 0) {
        this.$message.success(res.msg);
        this.getOperatorList();
      } else {
        this.$message.error(res.msg)
      }

      this.$emit("wdjsChange", { code: 1 }); //取消机手成功
    },
  },
};
</script>

<style lang="less" scoped>
.body {
  width: 100%;

  .title-area {
    padding: 0 20px;
    border-bottom: 1px solid #131313;
  }

  .machinerVoList-area {
    padding: 0 10px;

    .list-box {
      margin-top: 10px;
      border-radius: 6px;
      border: 1px solid black;
      padding: 10px;

      .top-info-area {
        display: flex;
        justify-content: space-between;

        .top-left-area {
          display: flex;

          .head {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background-color: #c7c7c7;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 24px;
            color: black;
            font-weight: 600;
          }

          .userName {
            padding-left: 10px;
            font-size: 18px;
          }
        }

        .top-right-area {
          width: 60px;
          padding-top: 10px;

          .symbol-y-area {
            display: flex;
            justify-content: center;

            .symbol {
              width: 10px;
              height: 10px;
              border-radius: 50%;
            }

            .red {
              background-color: red;
            }

            .green {
              background-color: green;
            }
          }

          .title {
            padding-top: 6px;
            font-size: 16px;
            text-align: center;
          }
        }
      }

      .info-box {
        display: flex;
        font-size: 16px;
        align-items: center;
        padding-top: 4px;

        .info-title {
          width: 80px;
        }
      }

      .button-area {
        display: flex;
        justify-content: flex-end;

        .cancel {
          background-color: red;
          color: #ffffff;
          border-radius: 16px;
          border: none;

        }

        .blue {
          margin-left: 20px;
          background-color: blue;
        }
      }
    }
  }
}
</style>
